import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
// import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import house_icon from "../../assets/icons/house_icon.png";
import clock_icon from "../../assets/icons/clock_icon.png";
import locationPin_icon from "../../assets/icons/locationPin_icon.png";
import users_icons from "../../assets/icons/users_icons.png";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComponents/Sidebar";
import adminWaveGraph from "../../assets/images/admin-wave-graph.png";
import adminPieChartGraph from "../../assets/images/admin-pie-chart-graph.png";

const AdminExhibition = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("upcoming");

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Exhibition Master" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Sidebar />}
        </div>
      </div>

      <div className="ml-4 mt-10">Exhibition Overview</div>

      {/*  */}
      <div className="bg-[#ffbe1a23] flex justify-around w-[90%] mt-6 ml-4 px-4 overflow-auto]">
        <div>
          <div
            className={`relative py-4 px-5 text-[12px] cursor-pointer flex justify-center ${
              activeTab === "upcoming" ? "active-prospects" : ""
            }`}
            onClick={() => handleTabClick("upcoming")}
          >
            Upcoming Exhibition
            <div
              className={`${
                activeTab === "upcoming" ? "active-underline" : ""
              }`}
            ></div>
          </div>
        </div>
        <div>
          <div
            className={`relative py-4 px-5 text-[12px] cursor-pointer flex justify-center ${
              activeTab === "completed" ? "active-prospects" : ""
            }`}
            onClick={() => handleTabClick("completed")}
          >
            Completed Exhibition
            <div
              className={`${
                activeTab === "completed" ? "active-underline" : ""
              }`}
            ></div>
          </div>
        </div>
      </div>

      {activeTab === "upcoming" ? (
        <div className="flex mb-8 mt-4 mx-4 justify-between exhibition">
          <div className="w-[95%]">
            {/* Exhibition Name 1 */}
            <div className="border rounded-lg">
              <div className="p-4">
                <p className="text-[#333333] font-bold text-16px">
                  Exhibition Name 1
                </p>
                <div className="flex justify-between items-center">
                  <div className="text-[14px]">
                    <div className="flex">
                      <img
                        src={house_icon}
                        className="w-3 object-contain mr-1"
                        alt="house icon"
                      />
                      <p>23rd Oct 2023 - 25th Oct 2023</p>
                    </div>
                    <div className="flex mt-1">
                      <img
                        src={clock_icon}
                        className="w-3 object-contain mr-1"
                        alt="clock icon"
                      />
                      <p>10:00am - 13:00pm</p>
                    </div>
                  </div>
                  <div>
                    <img src={locationPin_icon} alt="location" />
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center bg-[#ECECEC] px-4 rounded-b-lg">
                <div className="flex text-[#989898] text-[14px] items-center py-2">
                  <div>Users</div>
                  <img src={users_icons} className="ml-2 w-20" alt="users" />
                </div>
                <div className="text-[#3485BB] underline text-[16px] cursor-pointer">
                  <Link to="">Invite users</Link>
                </div>
              </div>
            </div>

            {/* Exhibition Name 2 */}
            <div className="border rounded-lg mt-6">
              <div className="p-4">
                <p className="text-[#333333] font-bold text-16px">
                  Exhibition Name 2
                </p>
                <div className="flex justify-between items-center">
                  <div className="text-[14px]">
                    <div className="flex">
                      <img
                        src={house_icon}
                        className="w-3 object-contain mr-1"
                        alt="house"
                      />
                      <p>03rd Oct 2023 - 05th Oct 2023</p>
                    </div>
                    <div className="flex mt-1">
                      <img
                        src={clock_icon}
                        className="w-3 object-contain mr-1"
                        alt="house"
                      />
                      <p>10:00am - 13:00pm</p>
                    </div>
                  </div>
                  <div>
                    <img src={locationPin_icon} alt="location" />
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center bg-[#ECECEC] px-4 rounded-b-lg">
                <div className="flex text-[#989898] text-[14px] items-center py-2">
                  <div>Users</div>
                  <img src={users_icons} className="ml-2 w-20" alt="house" />
                </div>
                <div className="text-[#3485BB] underline text-[16px] cursor-pointer">
                  <Link to="">Invite users</Link>
                </div>
              </div>
            </div>

            {/* Add new Exhibition */}
            <div className="bg-[#2F80ED] mt-6 p-3 rounded-lg text-white text-[14px] text-center cursor-pointer">
              Add New Exhibition
            </div>
          </div>
        </div>
      ) : null}

      {activeTab === "completed" ? (
        <div className="ml-4 w-[90%] ">
          <div className="flex justify-end mt-4">
            <div className="flex items-center px-4 bg-white shadow-lg border border-[#F7F1E1] rounded-lg cursor-pointer mr-2 text-[#3485BB]">
              <div className="text-[12px]">Year 2023</div>
              <span className="text-md ml-2 mb-3 font-semibold">&#x2304;</span>
            </div>
          </div>

          <div className="px-4 py-2 border rounded-lg flex justify-between items-center mt-4">
            <div>
              <p className="text-[#333333] font-bold text-[16px]">
                Exhibition Name 2
              </p>
              <div className="flex mt-2 text-[14px]">
                <img
                  src={house_icon}
                  className="w-3 object-contain mr-1"
                  alt="house"
                />
                <p className="font-normal">03rd Oct 2023 - 05th Oct 2023</p>
              </div>
            </div>

            <div>
              <img
                src={locationPin_icon}
                alt="location"
                className="w-10 object-contain"
              />
            </div>
          </div>
          <div className="px-4 py-2 border rounded-lg flex justify-between items-center mt-4">
            <div>
              <p className="text-[#333333] font-bold text-[16px]">
                Exhibition Name 2
              </p>
              <div className="flex mt-2 text-[14px]">
                <img
                  src={house_icon}
                  className="w-3 object-contain mr-1"
                  alt="house"
                />
                <p className="font-normal">03rd Oct 2023 - 05th Oct 2023</p>
              </div>
            </div>

            <div>
              <img
                src={locationPin_icon}
                alt="location"
                className="w-10 object-contain"
              />
            </div>
          </div>
          <div className="px-4 py-2 border rounded-lg flex justify-between items-center mt-4">
            <div>
              <p className="text-[#333333] font-bold text-[16px]">
                Exhibition Name 2
              </p>
              <div className="flex mt-2 text-[14px]">
                <img
                  src={house_icon}
                  className="w-3 object-contain mr-1"
                  alt="house"
                />
                <p className="font-normal">03rd Oct 2023 - 05th Oct 2023</p>
              </div>
            </div>

            <div>
              <img
                src={locationPin_icon}
                alt="location"
                className="w-10 object-contain"
              />
            </div>
          </div>
          <div className="px-4 mb-4 py-2 border rounded-lg flex justify-between items-center mt-4">
            <div>
              <p className="text-[#333333] font-bold text-[16px]">
                Exhibition Name 2
              </p>
              <div className="flex mt-2 text-[14px]">
                <img
                  src={house_icon}
                  className="w-3 object-contain mr-1"
                  alt="house"
                />
                <p className="font-normal">03rd Oct 2023 - 05th Oct 2023</p>
              </div>
            </div>

            <div>
              <img
                src={locationPin_icon}
                alt="location"
                className="w-10 object-contain"
              />
            </div>
          </div>

          {/* Graphs */}
          <div className="flex justify-start w-[95%] ml-4 mt-4 graphs mb-8">
            <img
              src={adminWaveGraph}
              className="object-contain w-[50%] plan--card"
              alt="admin wave graph"
            />
            <img
              src={adminPieChartGraph}
              className="object-contain w-[33%] ml-4 plan--card"
              alt="admin pie chart graph"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AdminExhibition;
